module.exports = __webpack_public_path__ + "static/media/Acc-2b.cb06a647.png";